import axiosInstance from "@/api/axiosInstance";

export interface CompanyUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
}

export class CompanyUserService {
  public async getUsers(): Promise<CompanyUser[]> {
    const response = await axiosInstance.get("/api/v1/company/users");
    return response.data;
  }

  public async inviteUser(email: string): Promise<void> {
    await axiosInstance.post("/api/v1/company/users/invite", { email });
  }

  public async validateToken(token: string): Promise<{ email: string }> {
    const response = await axiosInstance.get(
      "/api/v1/company/register/validate",
      {
        params: { token },
      }
    );
    return response.data;
  }

  public async registerUser(data: {
    token: string;
    firstName: string;
    lastName: string;
    password: string;
  }): Promise<void> {
    await axiosInstance.post("/api/v1/company/register", data);
  }
}
